var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSignpost = function SvgIconSignpost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2a1 1 0 0 1 1 1v2.75h6.125a1 1 0 0 1 .743.331l3.375 3.75a1 1 0 0 1 0 1.338l-3.375 3.75a1 1 0 0 1-.743.331H13V21a1 1 0 1 1-2 0v-5.75H3.75A1.75 1.75 0 0 1 2 13.5v-6a1.75 1.75 0 0 1 1.75-1.75H11V3a1 1 0 0 1 1-1m6.68 11.25 2.475-2.75-2.475-2.75H4v5.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSignpost;